import { cva, VariantProps } from "class-variance-authority";
import React from "react";

type IconWrapperVariants = VariantProps<typeof iconWrapperVariants>;

interface IconWrapperProps
  extends React.HTMLAttributes<HTMLDivElement>,
    IconWrapperVariants {
  icon: React.ReactNode;
  className?: string;
}
const iconWrapperVariants = cva(
  "flex items-center justify-center p-2 rounded h-9 w-9", // Base styles
  {
    variants: {
      variant: {
        default: "bg-primary",
        primary: "bg-icon-secondary",
        secondary: "bg-dashboard",
      },
      defaultVariants: {
        variant: "default",
      },
    },
  }
);
const IconWrapper = React.forwardRef<HTMLDivElement, IconWrapperProps>(
  ({ icon, className, variant, ...props }, ref) => (
    <div
      ref={ref}
      className={iconWrapperVariants({ variant, className })}
      {...props}
    >
      {icon}
    </div>
  )
);

export default IconWrapper;
